import {Column} from 'react-table'
import {ActionPlansActionsCell} from './ActionPlansActionsCell'
import {ActionPlansCustomHeader} from './ActionPlansCustomHeader'
import {ActionPlans} from '../../core/_models'
import {ActionPlansLicenseNumber} from './ActionPlansLicenseNumber'
import {ActionPlansResponsible} from './ActionPlansResponsible'
import {ActionPlansDescription} from './ActionPlansDescription'
import {ActionPlansNumber} from './ActionPlansNumber'
import {ActionPlansConclusionDate} from './ActionPlansConclusionDate'
import {ActionPlansPredictedDate} from './ActionPlansPredictedDate'
import {ActionPlansStatus} from './ActionPlansStatus'

import {ActionPlansCost} from './ActionPlansCost'

const ActionPlansColumns: ReadonlyArray<Column<ActionPlans>> = [
  //HEADER COLUMN - PROJECT
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='CONDITIONINGS.LICENSE_NUMBER'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'license',
    Cell: ({...props}) => <ActionPlansLicenseNumber ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.CONDITIONINGS_NUMBER'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'Conditioning_number',
    Cell: ({...props}) => <ActionPlansNumber ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTREPRENEUR
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.RESPONSIBLE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'responsible',
    Cell: ({...props}) => <ActionPlansResponsible ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTERPRISES
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <ActionPlansDescription ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => <ActionPlansStatus ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.PREDICTED_DATE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'predicted_date',
    Cell: ({...props}) => <ActionPlansPredictedDate ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - expiration_date ***
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='COMMON.CONCLUSION_DATE'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'conclusion_date',
    Cell: ({...props}) => <ActionPlansConclusionDate ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  FIELDS ***
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='CONDITIONINGS.COST'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'conditioning_cost',
    Cell: ({...props}) => <ActionPlansCost ActionPlans={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <ActionPlansCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-100px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <ActionPlansActionsCell ActionPlans={props.data[props.row.index]} />,
  },
]

export {ActionPlansColumns}
